;(function() {
/* @ngInject */
function FormSubmitSectionController() {
    let vm = this;
}

angular.module("firmaren")
    .component("formSubmitSection", {
        templateUrl: "/app/shared/form-submit-section/form-submit-section.html",
        controller: FormSubmitSectionController,
        controllerAs: "vm",
        bindings: {
            requiredCheckbox: "<",
            agreements: "=",
            contactMe: "=",
            preAgreementInfo: "@",
            onBackClick: "&",
            onFinishClick: "&",
            onSaveForLaterClick: "&",
            inProgress: "=",
            hasTbMemorandum: "<",
            upsell: "=",
            tbLabel: "@",
            hideRepresentation: "<",
            additionalAgreementLabel: "@"
        }
    });
}());
